import type { AxiosRequestConfig, AxiosResponse } from 'axios'

import { getAdminOrgScope } from '../admin-org-scope'
import { adminHttpClient, serviceClient } from '../http-client'
import { ADMIN_API_PREFIX, COMMUNICATION_SERVICE_PATH } from '../paths'

export const communicationAdminHttpClient = <T = unknown>(
  config: AxiosRequestConfig & { url: string },
): Promise<T> =>
  adminHttpClient<T>({
    ...config,
    url: `${COMMUNICATION_SERVICE_PATH}${ADMIN_API_PREFIX}${config.url}`,
  })

/**
 * Console twin of the product's `communicationHttpClient`, for the vendored
 * pages that call it directly (the campaign CSV exports). It resolves to the
 * full `AxiosResponse` like the product's does, and reroutes a product path
 * onto its console twin: `/api/v1/campaigns/…` is the outreach twin at
 * `/product/outreach-campaigns/…` (the plain `/product/campaigns` is 10DLC),
 * anything else `/api/v1/x` is `/product/x`. The scoped tenant rides along.
 */
export const communicationHttpClient = <T = unknown>(
  config: AxiosRequestConfig & { url: string },
): Promise<AxiosResponse<T>> => {
  const path = config.url
    .replace(/^\/api\/v1\/campaigns(?=\/|$)/, '/outreach-campaigns')
    .replace(/^\/api\/v1\//, '/')
  const organization_id = getAdminOrgScope()
  return serviceClient.request<T>({
    ...config,
    url: `${COMMUNICATION_SERVICE_PATH}${ADMIN_API_PREFIX}/product${path}`,
    params: {
      ...(organization_id ? { organization_id } : {}),
      ...(config.params as Record<string, unknown> | undefined),
    },
  })
}
